import { Box, Header, Text } from '@rbilabs/universal-components';

import { ZIndex, getDesignToken } from 'styles/constants';
import { primitive } from 'styles/constants';

export const Container = Box.withConfig({
  flexDir: 'column',
  padding: '$4',
});

export const StoreCardViewContainer = Box.withConfig({
  position: 'relative',
  overflow: 'hidden',
  flex: 1,
});

export const Wrapper = Box.withConfig(({ isSelected }: { isSelected: boolean }) => ({
  borderBottomWidth: 1,
  borderColor: 'blackOpacity.10',
  position: 'relative',
  zIndex: ZIndex.BELOW,
  backgroundColor: getDesignToken('background-card'),
  ...(isSelected && {
    borderWidth: '2px',
    borderColor: primitive.$fieryRed,
  }),
}));

export const Address = Header.withConfig({
  variant: 'headerThree',
  marginBottom: 0, // Reset default margin bottom
  marginY: '$1',
  underline: true,
  focusable: false,
});

export const ServiceModes = Text.withConfig({
  variant: 'copyTwo',
});

export const Status = Text.withConfig(
  ({ isOpen, isWithinOneHourOfClose }: { isOpen: boolean; isWithinOneHourOfClose: boolean }) => ({
    variant: 'copyOne',
    fontSize: 'sm',
    fontFamily: 'heading',
    marginTop: '$1',
    focusable: true,
    color: isWithinOneHourOfClose
      ? primitive.$chkingOrange
      : isOpen
      ? primitive.$crunchyGreen
      : primitive.$fieryRed,
  })
);

export const Distance = Text.withConfig({
  fontFamily: 'heading',
  focusable: true,
});
